import React from 'react'
import Header from '../Components/Header/header'
import LandingPage from '../Components/LandingPage/landingpage'
import CounterSection from '../Components/CounterSection/countersection'
import CallToAction from '../Components/Calltoaction/calltoaction'
import Tabs from '../Components/Tabs/tabs'
import Footer from '../Components/Footer/footer'
import About from '../Components/About/about'
import Services from '../Components/Services/services'
import Reels from '../Components/Reels/reels'
import Pricing from '../Components/Pricing/pricing'
import Contact from '../Components/Contact/contact'
import SocialMediaTab from '../Components/SocialMediaTab/SocialMediaTab'
import BackToTopButton from '../Components/BackToTopButton/BackToTopButton'

const Home = () => {
  return (
    <div>
      <Header/>
      <LandingPage/>
      <About/>
      <Reels/>
      <Tabs/>
      <CounterSection/>
      <CallToAction/>
      <Services/>
      <Pricing/>
      <Contact/>
      <Footer />
      <SocialMediaTab/>
      <BackToTopButton/>
    </div>
  )
}

export default Home